import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import FailedIcon from "../../resources/icons/warning-thin.svg";
import AuthContext from "../../store/auth-context";
import ToolTip from "../../common/ToolTip/ToolTip";
import { useTranslation } from "react-i18next";
import { pageRootTestIds } from "../../testing/pageRootTestIds";

const FailedEmailIdentity = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const authContext = useContext(AuthContext);
  const handleTestEmailClick = () => {
    navigate("/issuer/settings?section=email-address");
  };
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4" id={pageRootTestIds.failedEmailIdentity}>
      <div className="flex flex-col items-center max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="flex items-center justify-center mb-2">
          <img src={FailedIcon} height={50} width={50} alt="" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {t("authPages:verification_failed_title")}
        </h1>
        <p className="text-gray-600 mb-6">
          {t("authPages:verification_failed_desc")}
        </p>
        {authContext.isLoggedIn ? (
          <button
            onClick={handleTestEmailClick}
            id="failed-email-identity-retry"
            className="w-[50%] px-4 py-2 rounded-md text-cfSecondary font-medium bg-cfPrimaryButton transition-colors duration-200 ease-in-out hover:bg-cfPrimaryDarkBlue"
          >
            {t("authPages:retry_verification")}
          </button>
        ) : (
          <ToolTip
            component={
              <button
                disabled
                id="failed-email-identity-retry-disabled"
                className="w-full px-4 py-2 rounded-md text-cfSecondary font-medium bg-cfIssuedScreenTabButtonUnSelectedText"
              >
                {t("authPages:retry_verification")}
              </button>
            }
            message={t("authPages:signin_retry_verification")}
            tooltipPosition={"top-[-2.8rem]"}
            bgColor={"#E0781A"}
            tooltipWidth={"max-w-[300px]"}
          />
        )}
        <p className="mt-4 text-sm text-gray-500">
          {t("authPages:contact_support_desc")}
        </p>
      </div>
    </div>
  );
};

export default FailedEmailIdentity;
